import { Controller } from "@hotwired/stimulus"

// How a member says "not right now" without leaving the one form that
// puts their account back together.
//
// Setting the budget to zero rather than offering a way to skip the
// plan is deliberate: a zero-budget plan is an ordinary, supported
// state that still gets created and still gets a card attached, so the
// member ends up with a complete account they can turn back up later.
// Skipping would leave a plan with nothing behind it and no path back
// through this page, which they only see once.
export default class extends Controller {
  static targets = ["budget"]

  zero(event) {
    event.preventDefault()

    this.budgetTarget.value = "0"
    // Bubbles so anything watching the field for changes sees this the
    // same way it sees typing.
    this.budgetTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.budgetTarget.focus()
  }
}
